<template>
  <div class="wscn-http404-container">
    <div class="pic-404">
      <img class="pic-404__parent" src="@/assets/error.png" alt="404" />
    </div>
    <div class="bullshit" v-if="errorMessage">
      <div class="bullshit__oops">提示!</div>
      <div class="bullshit__headline">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "errorLoginPage",
  data() {
    return {
      errorMessage: "",
    };
  },
  mounted() {
    this.errorMessage = sessionStorage.getItem("errorMessage");
    if (this.errorMessage==='onsole is not defined') {
this.errorMessage=''
    }
  },
  methods: {
    goback() {
      this.$router.go(-1); //返回上一页
      this.$router.go(-1); //返回上一页
    },
  },
};
</script>

<style scoped lang="less">
.wscn-http404-container {
  width: 100vw;
  height: 100vh;
  background-color: #060f1d;
  position: relative;
  .pic-404 {
    position: absolute;
    top: calc((100vh - 300px) / 2);
    left: calc((100vw - 200px) / 2);
  }
  .pic-404__parent {
    width: 200px;
    height: 300px;
  }
}
.bullshit {
  height: 220px;
  position: absolute;
  top: calc((100vh - 300px) / 2 + 230px);
  left: calc((100vw - 282px) / 2);
  .bullshit__oops {
    font-size: 24px;
    font-weight: bold;
    color: #20c5ce;
  }
  .bullshit__headline {
    margin-top: 20px;
    font-size: 20px;
    font-weight: bold;
    color: #fff;
  }
  .bullshit__info {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 35px;
  }
  .bullshit__return-home {
    padding: 10px 35px;
    background: #0b5879;
    font-size: 14px;
    color: #20c5ce;
    border-radius: 18px;
    cursor: pointer;
  }
}
</style>
